<template>
  <div class="el-tabs-container">
    <!-- <PriceDiscTableSales></PriceDiscTableSales> -->
    <el-tabs v-model="tab_index">
      <el-tab-pane label="销售价格协议">
        <span slot="label">{{$t("tab.tab_price_disc_sales")}}</span>
        <PriceDiscTableSales></PriceDiscTableSales>
      </el-tab-pane>
      <el-tab-pane label="采购价格协议">
        <span slot="label">{{$t("tab.tab_price_disc_purch")}}</span>
        <PriceDiscTablePurch></PriceDiscTablePurch>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PriceDiscTableSales from "./PriceDiscTableSales";
import PriceDiscTablePurch from "./PriceDiscTablePurch";

export default {
  name: "InventTableMain",
  components: {
    PriceDiscTableSales,
    PriceDiscTablePurch
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
